import React from 'react';
import Main from './components/Main';

import './styles/main.css';

function App() {
  return (
    <div className="app">
      <Main />
    </div>
  );
}

export default App;